var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 497 497",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcca19",
    d: "M379.59 450.704H122.348c-11.046 0-20-8.954-20-20V61.358H69.2c-12.103 0-21.914 9.811-21.914 21.914v391.815C47.286 487.189 57.097 497 69.2 497h288.477c12.103 0 21.914-9.811 21.914-21.914v-24.382z",
    opacity: 1,
    "data-original": "#8ac9fe"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60b7ff",
    d: "M102.348 61.358v369.346c0 11.046 8.954 20 20 20H379.59v24.383c0 4.268-1.225 8.249-3.336 11.617H104.262c-12.102 0-21.913-9.811-21.913-21.914v-16l10-375.815z",
    opacity: 1,
    "data-original": "#60b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed402",
    d: "M414.652 415.642H157.41c-11.046 0-20-8.954-20-20V35.062h-33.148c-12.102 0-21.913 9.811-21.913 21.914V448.79c0 12.103 9.811 21.914 21.913 21.914h288.477c12.103 0 21.914-9.811 21.914-21.914v-33.148z",
    opacity: 1,
    "data-original": "#fed402",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac600",
    d: "M137.41 35.062v360.58c0 11.046 8.954 20 20 20h257.242v33.148c0 1.784-.218 3.515-.62 5.175H139.323c-12.102 0-21.913-9.811-21.913-21.914v-18.323l10-27.665V40.237z",
    opacity: 1,
    "data-original": "#fac600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efedef",
    d: "M425.8 435.642H139.323c-12.102 0-21.913-9.811-21.913-21.914V21.914C117.41 9.811 127.221 0 139.323 0h221.616l86.774 88.774v324.954c.001 12.103-9.81 21.914-21.913 21.914z",
    opacity: 1,
    "data-original": "#efedef",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7d0d6",
    d: "M419.714 58.774v354.954c0 12.103-9.811 21.914-21.913 21.914h30c12.103 0 21.913-9.811 21.913-21.914V88.774z",
    opacity: 1,
    "data-original": "#d7d0d6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5adb6",
    d: "M449.714 88.774H382.85c-12.1 0-21.91-9.809-21.91-21.91V0zM383.64 169.733H183.484a7.5 7.5 0 0 1 0-15H383.64a7.5 7.5 0 0 1 0 15zM383.64 225.321H183.484a7.5 7.5 0 0 1 0-15H383.64a7.5 7.5 0 0 1 0 15zM383.64 280.909H183.484a7.5 7.5 0 0 1 0-15H383.64a7.5 7.5 0 0 1 0 15z",
    opacity: 1,
    "data-original": "#b5adb6",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.e2a16e4fd661926bc9772c1bd565ff13.svg";
export { ForwardRef as ReactComponent };